export default __webpack_public_path__ + "static/media/refesh_gray.9d069acc.svg";